import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

const services = [
    {
        text: "Clickup.",
    },
    {
        text: "Monday.com",
    },
    {
        text: "Asana.",
    }
]

const variants = {
    hidden: { opacity: 0, translateY: 100 },
    visible: { opacity: 1, translateY: 0 },
    exit: { opacity: 0, translateY: -100 },
}

const AnimationText = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);


    return (
        <span className="inline-block pl-2 h-[24px] md:h-[32px] lg:h-[47px]">
            <span className="w-[150px] md:w-[200px] lg:w-[300px] h-[30px] md:h-[40px] lg:h-[55px] relative overflow-hidden flex justify-start items-center">
                <AnimatePresence>
                    <motion.span key={currentIndex} className="text-blue30 absolute" variants={variants} initial="hidden" animate="visible" exit="exit">{services[currentIndex].text}</motion.span>
                </AnimatePresence>
            </span>
        </span>
    )
}

const Animation = () => {
    return (
        <div className="w-full flex flex-col px-4 md:px-8 lg:px-16 py-32 md:py-40 lg:py-52 container mx-auto items-center justify-center text-center gap-2">
            <h2 className="leading-tight lg:leading-tight lg:text-5xl md:text-2xl text-2xl font-normal pointer-events-none text-blue10">
            ReadyPMO solves these challenges by delivering a complete, proven, ready-to-use PM system—anchored in 
                <AnimationText />
            </h2>
        </div>
    );
}

export default Animation;